import React from "react";
import { ChannelProvider, useIsChannelList } from "../../hooks";
const Channel = ({ channel, children, }) => {
    const isList = useIsChannelList();
    if (isList) {
        return React.createElement(React.Fragment, null, children);
    }
    if (!channel)
        return React.createElement("p", null, " loading ...");
    return React.createElement(ChannelProvider, { channel: channel }, children);
};
export default Channel;
//# sourceMappingURL=Channel.js.map